var exports = {
  "i1": "InterfaceTab.module__previewContainer___R3J4bj",
  "gp": "InterfaceTab.module__previewContent___R3J4bj",
  "rv": "InterfaceTab.module__tooltipContent___R3J4bj",
  "zX": "InterfaceTab.module__typingContainer___R3J4bj",
  "ro": "InterfaceTab.module__typingAnimationWrapper___R3J4bj",
  "OI": "InterfaceTab.module__typingAvatars___R3J4bj",
};

module.exports = exports;
